export const environment = {
  production: true,
  hmr: false,
  canonicalDomain: 'https://mullerbog.nl',
};
